import React from "react";
import ProdutoModel from "../model/ProdutoModel";
import Slider from "react-slick";
import ConfiguracoesCarrosselPadrao from "./ConfiguracoesCarrosselPadrao";
import ProdutoItem from "./ProdutoItem";
import { ReactComponent as ImagemLogoBemQuerer } from "../assets/images/cliente-bem-querer.svg";
import { Link } from "react-router-dom";

type GrupoProdutosProps = {
  titulo: string;
  tituloImagem?: string;
  items: ProdutoModel[];
  linkMais?: string;
  parent?: React.Component;
  verMais?: boolean;
  adicionarTodos?: any;
};

type GrupoProdutosState = {};

class GrupoProdutos extends React.Component<
  GrupoProdutosProps,
  GrupoProdutosState
> {
  constructor(props: GrupoProdutosProps) {
    super(props);

    this.state = {};
  }

  render(): any {
    const { titulo, items, linkMais, verMais, adicionarTodos } = this.props;

    let classObject: string = "products";
    if (titulo === "Cliente bem querer") {
      classObject += " bem-querer";
    }

    if (titulo === "Green Friday") {
      classObject += " bf";
    }

    if (items.length === 0) {
      return <></>;
    }

    const imagemHeader = [
      'Cliente bem querer',
      'Green Friday'
    ];


    return (
      <div className="product-group">
        <div className="header">
          {!imagemHeader.some(t => t === titulo) && <h2>{titulo}</h2>}
          {titulo === "Cliente bem querer" && (
            <h2>
              <ImagemLogoBemQuerer />
            </h2>
          )}
          {titulo === "Green Friday" && (
            <h2>
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/assets/images/banner_fw.png`}
                width="324" />
            </h2>
          )}
          {linkMais && linkMais.length > 0 && (
            <div className="more">
              <Link to={linkMais}>Ver mais</Link>
            </div>
          )}
          {adicionarTodos && (
            <div className="more" onClick={adicionarTodos}>
              Comprar
            </div>
          )}
        </div>
        <div className={classObject}>
          <Slider {...ConfiguracoesCarrosselPadrao} className="items">
            {items.map((item: ProdutoModel) => (
              <ProdutoItem
                item={item}
                key={item.produtoId}
                parent={this.props.parent ? this.props.parent : this}
              ></ProdutoItem>
            ))}
            {verMais && linkMais && (
              <div className="item more">
                <div>
                  <img
                    src="assets/images/icons/ver-mais-sem-foto.svg"
                    title="Ver mais"
                    alt="Ver mais"
                  />
                  <Link to={linkMais} replace>
                    Ver mais
                  </Link>
                </div>
              </div>
            )}
          </Slider>
        </div>
      </div>
    );
  }
}

export default GrupoProdutos;
